export const environment = {
  legacyAppUrl: 'https://backend.demo.brandshelter.com',
  legacyFrontendURL: 'https://demo.brandshelter.com',
  brandMonitoringPortalURL: 'https://www.mymonitoringportal.com',
  registerNewAccountUrl: '/signup',
  turnstileSiteKey: '0x4AAAAAACvaLveu5NhtObCI'
};
